// Campus photo for /colleges/university-of-st-thomas-minnesota: CC BY-SA 3.0, by AlexiusHoratius, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASt._Thomas_campus_5.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-st-thomas-minnesota/; credited under the photo.
const photo = {
    "slug": "university-of-st-thomas-minnesota",
    "alt": "Sandstone halls around the main quad at the University of St. Thomas in St. Paul, Minnesota",
    "src": "/colleges/university-of-st-thomas-minnesota/campus-1600.webp",
    "srcSmall": "/colleges/university-of-st-thomas-minnesota/campus-800.webp",
    "srcMid": "/colleges/university-of-st-thomas-minnesota/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-st-thomas-minnesota/og.jpg",
    "title": "St. Thomas campus 5",
    "author": "AlexiusHoratius",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASt._Thomas_campus_5.JPG",
    "read": "2026-10-01"
};

export default photo;
